import React, { useEffect } from 'react';

import { ReactComponent as ErrorIcon } from '/src/images/icons/error-icon.svg';

import { isBrowser } from '../../../helpers/is-browser';
import { useGetLibraryConstantsDictionary } from '../../../hooks/use-get-library-constants-dictionary';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import Button from '../../ui/button/button';

interface DynamicOfferRedemptionProps {
  className?: string;
  handleClose: () => void;
  errorMessage?: string;
  node_locale: string;
  tenantDetails: {
    offerName?: string;
    tenantName?: string;
    tenantLogo?: IContentfulImage;
  };
}

export const OfferRedemptionErrorScreen = ({
  className,
  handleClose,
  errorMessage = 'Offer can’t be claimed',
  node_locale,
  tenantDetails,
}: DynamicOfferRedemptionProps) => {
  const dictionary = useGetLibraryConstantsDictionary(node_locale);

  useEffect(() => {
    sendGtmEvent();
  }, []);

  const sendGtmEvent = () => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'offer_redemption',
        offer_name: tenantDetails?.offerName,
        offer_redeemed: 'No',
        offer_redeemed_QR: 'No',
      });
    }
  };

  return (
    <>
      <div className="text-headingm font-title gap-4 text-neutral-grey-700 text-center flex justify-center items-center flex-col">
        <ErrorIcon />
        {errorMessage}
      </div>
      <div className="button-container flex flex-col gap-4 mt-6">
        <Button variant="primary" onClick={handleClose}>
          {dictionary?.okayText}
        </Button>
      </div>
    </>
  );
};
